import {PredictUsageComponent} from './PredictUsageComponent';

export default PredictUsageComponent;
